// extracted by mini-css-extract-plugin
export default {"withBorder":"Row_withBorder__dD+lV","first":"Row_first__U6teO"};